import { render, staticRenderFns } from "./task-detail.vue?vue&type=template&id=39de18a4&scoped=true"
import script from "./task-detail.vue?vue&type=script&lang=js"
export * from "./task-detail.vue?vue&type=script&lang=js"
import style0 from "./task-detail.vue?vue&type=style&index=0&id=39de18a4&prod&lang=scss&scoped=true"
import style1 from "./task-detail.vue?vue&type=style&index=1&id=39de18a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39de18a4",
  null
  
)

export default component.exports